import React, { Component } from 'react'
import { Table } from 'antd'
import moment from 'moment'

class ListRepairOrder extends Component {
  getColumns = () => {
    return [
      {
        title: 'Id',
        dataIndex: 'job',
        render: item => {
          if (item && item.job_type) {
            let jobUrl = `/jobView/${item.job_id}/${item.job_type.replace(
              '/',
              '-'
            )}/change-orders/modal/${item.id}`
            return (
              <a href={jobUrl} target="_blank">
                {item.id}
              </a>
            )
          }
        }
      },
      {
        title: 'Description',
        dataIndex: 'description'
      },
      {
        title: 'Status',
        dataIndex: 'status'
      },
      {
        title: 'Created Date',
        dataIndex: 'created_date'
      }
    ]
  }

  getData = () => {
    const { repairOrders } = this.props

    const data = repairOrders.map((repairOrder, index) => {
      // format date from db
      repairOrder.created_date = moment(new Date(repairOrder.created_date)).format('YYYY-MM-DD')
      const returnObj = Object.assign(
        {
          key: `${repairOrder.id}${index}`,
          job: {
            job_id: repairOrder.job_id,
            job_type: repairOrder.job_type,
            id: repairOrder.id
          }
        },
        repairOrder
      )
      return returnObj
    })
    return data
  }

  render() {
    return (
      <div>
        <h6>Rapair Orders</h6>
        <Table
          pagination={false}
          columns={this.getColumns()}
          dataSource={this.getData()}
          size="small"
          style={{ backgroundColor: 'white' }}
        />
      </div>
    )
  }
}

export default ListRepairOrder



// WEBPACK FOOTER //
// ./src/components/reports/general/open-items/ListRepairOrders.js